<template>
  <AppContainer
    id="bespoke-certification"
    class="overflow-hidden pt-32 md:overflow-visible md:pt-40">
    <div
      class="flex flex-col items-center gap-10 xl:flex-row xl:gap-20 dark:gap-0 dark:xl:gap-20">
      <div class="flex h-[500px] flex-1 items-center">
        <NuxtImg
          loading="lazy"
          src="/images/homepage/tailored.svg"
          class="mx-auto hidden w-full shrink-0 scale-150 md:scale-125 xl:mt-28 dark:block"
          alt="Tailored Certification" />
        <NuxtImg
          loading="lazy"
          src="/images/homepage/tailored-light.svg"
          class="mx-auto w-full shrink-0 xl:mt-10 dark:hidden"
          alt="Tailored Certification" />
      </div>
      <div class="flex w-full max-w-xl flex-col items-center gap-10 xl:w-152 xl:max-w-full xl:items-start">
        <h2 class="heading-primary text-center text-3xl font-bold md:text-[40px] md:leading-tight xl:pr-20 xl:text-left">
          <em>Tailor-Made Certification </em>for Your Technology
        </h2>
        <p class="text-center text-sm text-eerie-black md:text-base xl:text-left dark:text-white">
          The team can develop a custom certification for your technology to ensure that developers are making the best use of your product, as well as enjoying the other benefits that certification delivers.
          <br>
          <br>
          Chat to us on how we can build a solution for you.
        </p>
        <NuxtLink
          to="mailTo:team@certificates.dev"
          external
          class="btn-primary w-full px-8 py-4 xl:w-fit">
          Contact Us
        </NuxtLink>
      </div>
    </div>
  </AppContainer>
</template>
<script setup lang="ts">
</script>
